export default class AccessibilityFontSite {
    constructor() {
        this.storageKey = 'font-size-preference';

        this.fontSize = {};
        this.getFontSizePreference();

        this.setPreference();

        this.btnChangeFontSize = document.querySelectorAll('.fontsize .option');

        this.ready();
    }

    ready() {
        if (this.btnChangeFontSize) {
            this.btnChangeFontSize.forEach((el) => {
                el.addEventListener('click', () => {
                    this.fontSize.value = el.dataset.fontsize;
                    this.setPreference();
                });
            });
        }
    }

    changeFontSize() {
        document.querySelector('html').style.fontSize = this.fontSize.value + 'px';

        let activeOption = document.querySelectorAll('.fontsize .option.active');

        if (activeOption) {
            activeOption.forEach(function (btn) {
                btn.classList.remove('active');
            });
        }

        const setActiveOption = document.querySelectorAll('.fontsize [data-fontsize="' + this.fontSize.value + '"]');
        setActiveOption.forEach(function (btn) {
            btn.classList.add('active');
        });
    }

    setPreference() {
        localStorage.setItem(this.storageKey, this.fontSize.value);
        this.changeFontSize();
    }

    getFontSizePreference() {
        // console.log(localStorage.getItem(this.storageKey));
        if (localStorage.getItem(this.storageKey) && localStorage.getItem(this.storageKey) != 'undefined') {
            this.fontSize.value = localStorage.getItem(this.storageKey);
        } else {
            this.fontSize.value = '16';
        }
    }
}
new AccessibilityFontSite();
